import { ContainerType } from "./Enum/InventoryExceptionType";

// models/ExceptionTypes.ts
export interface ExceptionTypeModel {
    id: number;
    containerType: ContainerType;
    name: string;
    isSerialNoException: boolean | false,
    isLotException: boolean | false,
    isCartonException: boolean | false,
    isPalletException: boolean | false,
    tooltipTitle?: string | "",
    tooltipMessages?: string | "",
    bannnerTitle?: string | "",
    bannerMessages?: string | "",
    fullTooltipTitle?: string | "",
    fullTooltipMessages?: string | "",
    fullTooltipLockMessages?: string | "",
    fullBannnerTitle?: string | "",
    fullBannerMessages?: string | "",
    isAdminOnlyView: boolean,
    exceptionResolveTitle?:string,
    exceptionResolveConfirmationMsg?:string

  }
  
  export const ExceptionTypes: readonly ExceptionTypeModel[] = [
    {
      id: 1,
      containerType:ContainerType.SerialNo,
      name: "DuplicateSerials",
      tooltipTitle: "Exception",
      tooltipMessages: "Duplicate Serial Number",
      bannnerTitle: "Inventory Exception: ",
      bannerMessages: "Duplicate Serial Number Exception found",
      fullTooltipTitle: "Duplicate Serial Number Exception",
      fullTooltipMessages: "A duplicate Serial Number has been detected in the inventory. Please review and resolve to ensure accuracy.",
      fullTooltipLockMessages: "A duplicate Serial Number has been detected in the inventory. Please review and resolve to ensure accuracy before locking the inventory.",
      fullBannnerTitle: "Inventory Exception: ",
      fullBannerMessages: "Duplicate Serial Number Exception found. Please verify and update it before locking the Inventory.",
      isSerialNoException: true,
      isLotException: false,
      isCartonException: false,
      isPalletException: false,
      isAdminOnlyView: false,
      exceptionResolveTitle: 'Duplicate Serial Numbers',
      exceptionResolveConfirmationMsg:'This action will accept all exceptions of Duplicate Serial Numbers for "<SelectedValue>"?'
    },
    {
      id: 2,
      containerType:ContainerType.Carton,
      name: "CartonsOnMultiplePallets",
      tooltipTitle: "Exception",
      tooltipMessages: "One Carton Linked to Multiple Pallets",
      bannnerTitle: "Inventory Exception: ",
      bannerMessages: "One Carton Linked to Multiple Pallets",
      fullTooltipTitle: "One Carton Linked to Multiple Pallets",
      fullTooltipMessages: "A single Carton Number is assigned to multiple Pallets. Please verify and correct the carton-to-pallet assignments.",
      fullTooltipLockMessages: "A single Carton Number is assigned to multiple Pallets. Please verify and correct the carton-to-pallet assignments before locking the inventory.",
      fullBannnerTitle: "Inventory Exception: ",
      fullBannerMessages: "One Carton Linked to Multiple Pallets. Please verify and update it before locking the Inventory.",
      isCartonException: true,
      isSerialNoException: false,
      isLotException: false,
      isPalletException: false,
      isAdminOnlyView: false,
      exceptionResolveTitle: 'One Carton Linked to Multiple Pallets',
      exceptionResolveConfirmationMsg:'This action will accept all exceptions of the Carton. Allow Carton to be linked to multiple Pallets for "<SelectedValue>"?'
    },
    {
      id: 3,
      containerType:ContainerType.Pallet,
      name: "PalletsOnMultipleLocations",
      tooltipTitle: "Exception",
      tooltipMessages: "One Pallet Linked to Multiple Locations",
      bannnerTitle: "Inventory Exception: ",
      bannerMessages: "One Pallet Linked to Multiple Locations",
      fullTooltipTitle: "One Pallet Linked to Multiple Locations",
      fullTooltipMessages: "A single Pallet Number is linked to multiple Locations. Please review and ensure Pallet assignment consistency.",
      fullTooltipLockMessages: "A single Pallet Number is linked to multiple Locations. Please review and ensure Pallet assignment consistency before locking the inventory.",
      fullBannnerTitle: "Inventory Exception: ",
      fullBannerMessages: "One Pallet Linked to Multiple Locations. Please verify and update it before locking the Inventory.",
      isPalletException: true,
      isSerialNoException: false,
      isLotException: false,
      isCartonException: false,
      isAdminOnlyView: false,
      exceptionResolveTitle: 'One Pallet Linked to Multiple Locations',
      exceptionResolveConfirmationMsg:'This action will accept all exceptions of the Pallet. Allow Pallet to be linked to multiple Locations for "<SelectedValue>"?'
    },
    {
      id: 4,
      containerType:ContainerType.NotContainer,
      name: "ItemCountMismatch",
      tooltipTitle: "Exception",
      tooltipMessages: "Item count mismatch",
      bannnerTitle: "Inventory Exception: ",
      bannerMessages: "Item count mismatch",
      fullTooltipTitle: "Item Count Mismatch",
      fullTooltipMessages: "The quantities recorded by the auditor and the counter don't align. Please reconcile.",
      fullTooltipLockMessages: "The quantities recorded by the auditor and the counter don't align. Please reconcile before locking the inventory.",
      fullBannnerTitle: "Inventory Exception: ",
      fullBannerMessages: "Item count mismatch. Please verify and update it before locking the Inventory.",
      isPalletException: false,
      isSerialNoException: false,
      isLotException: false,
      isCartonException: false,
      isAdminOnlyView: true
    }
  ] as const;
  